import React, { useContext, useEffect, useRef, useState } from "react";
import UserContext from "../../components/context/UserContext";
import { FaRegCalendarAlt, FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import { MultiSelect } from "primereact/multiselect";
import { LuClipboardCheck, LuClock } from "react-icons/lu";
import { HiOutlineUsers } from "react-icons/hi2";
import { Offcanvas, Form, Button } from "react-bootstrap";
import AppointmentSidebar from "../../components/Appointment/AppointmentSidebar";
import { useLocation } from "react-router-dom";
import FieldHelpTooltip from "../../components/Help/FieldHelpTooltip";
import { HELP_CONTENT } from "../../components/Help/HelpContent";
import { FaCalendarPlus, FaUserPlus, FaFileInvoiceDollar } from "react-icons/fa";
import DashboardHeader from "../../components/Dashboard/DashboardHeader";
import KpiTileGrid from "../../components/Dashboard/KpiTileGrid";
import RevenueLineChart from "../../components/Dashboard/RevenueLineChart";
import StatusDonutChart from "../../components/Dashboard/StatusDonutChart";
import QuickActionsPanel from "../../components/Dashboard/QuickActionsPanel";
import TodaysScheduleList from "../../components/Dashboard/TodaysScheduleList";
import OpexReminderCard from "../../components/Dashboard/OpexReminderCard";
import { getBookingLabel } from "../../utils/industryLabels";
import { addMinutesToDateTime } from "../../utils/bookingTime";

// Normalizes a status name down to letters only so "Check Out", "Checked
// Out", "check-out" etc. all compare equal — used both for the tile counts
// and the calendar's status colors/labels so they can never drift apart.
const normStatus = (s) => (s || "").toString().toLowerCase().replace(/[^a-z]/g, "");

// Single source of truth for status -> color, shared by the calendar
// events (getStatusColors) and matched to the same colors the overview
// tiles use (Check In yellow, Check Out green, No Show orange, Cancelled
// red) so a booking's color on the calendar always matches its tile.
const STATUS_COLOR_RULES = [
  { test: (n) => n.includes("noshow"), colors: { bgColor: "#FFF4E5", borderColor: "#FD7E14", textColor: "#FD7E14" } },
  { test: (n) => n.includes("cancel"), colors: { bgColor: "rgba(255, 204, 204, 0.5)", borderColor: "#FF0000", textColor: "#CC0000" } },
  { test: (n) => n.includes("checkout") || n.includes("checkedout") || n === "completed", colors: { bgColor: "rgba(204, 255, 226, 0.5)", borderColor: "#28A745", textColor: "#1E7E34" } },
  { test: (n) => n.includes("checkin") || n.includes("checkedin"), colors: { bgColor: "rgba(255, 255, 204, 0.5)", borderColor: "#CCCC00", textColor: "#666600" } },
  { test: (n) => n.includes("progress"), colors: { bgColor: "#FFF0FD", borderColor: "#92007E", textColor: "#92007E" } },
];
const DEFAULT_STATUS_COLORS = {  bgColor: "#FFF0FD", borderColor: "#92007E", textColor: "#92007E"  };

const Dashboard = () => {
  const location = useLocation();
  
  // window.location.reload();
  const [initialData, setInitialData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    const d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    return `${d1[2]}-${d1[1]}-${d1[0]}`;
  });
  // selectedDate doubles as the range's start date. rangeEnd is null for a
  // plain single-date pick — the "Filter by" DatePicker (selectsRange) sets
  // both together, so picking just one date (or clicking the same date
  // twice) leaves rangeEnd null/equal-to-start and everything below keeps
  // behaving exactly like single-date mode.
  const [rangeEnd, setRangeEnd] = useState(null);
  const isRange = !!rangeEnd && rangeEnd !== selectedDate;
  const rangeStartDate = selectedDate;
  const rangeEndDate = rangeEnd || selectedDate;
  const { vendor, refreshVendorData } = useContext(UserContext);
  const flagCount = useRef(0);
  const processedOpenAppointmentKey = useRef(null);
  const [open, setOpen] = useState(false);
  const dateFilterRef = useRef(null);
  const navigate = useNavigate();
const [allCrews, setAllCrews] = useState([]);        // original (master)
  const [availabilityMap, setAvailabilityMap] = useState({});
  const [filteredCrews, setFilteredCrews] = useState([]); // filtered
  const [industry, setIndustry] = useState(null);
  
  const [orderCounts, setOrderCounts] = useState({
    total: 0,
    completed: 0,
    progress: 0,
    cancelled: 0,
    checkedIn: 0,
    checkedOut: 0,
    noShow: 0,
  });

  // Rolling-week overview data (tiles' trend badges, the revenue chart, the
  // status donut, and the Upcoming Bookings list) — separate from the
  // existing single-day fetch above, which "Today's Schedule" and the
  // calendar still use exactly as before.
  const emptyWeekCounts = { total: 0, completed: 0, progress: 0, cancelled: 0, checkedIn: 0, checkedOut: 0, noShow: 0, unassigned: 0, revenue: 0 };
  const [weekCounts, setWeekCounts] = useState(emptyWeekCounts);
  const [prevWeekCounts, setPrevWeekCounts] = useState(emptyWeekCounts);
  const [revenueByDay, setRevenueByDay] = useState([]);
  const [upcomingRows, setUpcomingRows] = useState([]);

  // Close the "Filter by" date popup on an outside click - it otherwise
  // stays open until the calendar button is clicked again.
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (event) => {
      if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

    useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await apicall.get("ezpMyProfile");
        const profile = response?.data?.[0];
        if (profile) {
          setIndustry(profile);
        }
      } catch (e) {
        console.error("Failed to fetch profile for currency:", e);
      }
    };
    fetchProfile();
  }, []);

  const isClinicService =  industry?.industry === 1
  const isSportsService = industry?.industry === 7
  const isCarService = industry?.industry === 8
  const crewLabel = isClinicService ? "Doctor" : isSportsService ? "Coach" : isCarService ? "Service Provider" : "Crew"

  // Same labels the overview tiles use, keyed by weekKey — reused to show
  // "Filtered by: Check Out" above Today's Schedule when a tile is active.
  const TILE_LABELS = isClinicService
    ? { checkedIn: "Check In", checkedOut: "Check Out", noShow: "No Show", cancelled: "Cancelled" }
    : { completed: "CheckedIn", progress: "Progress", unassigned: "Unassigned", cancelled: "Cancelled" };

  useEffect(() => {
  // Guard against this firing more than once for the same navigation — e.g.
  // React 18 StrictMode's double-invoke in dev, or the effect re-running
  // before window.history.replaceState (which React Router doesn't observe,
  // since it bypasses its own history object) has taken effect — which was
  // causing the sidepanel to visibly open/close/open again.
  if (location.state?.openAppointment && processedOpenAppointmentKey.current !== location.key) {
    processedOpenAppointmentKey.current = location.key;
    if (location.state?.editGroupId) {
      setEditGroupId(location.state.editGroupId);
      setCanvasType("edit");
    } else {
      setEditGroupId(null);
      setCanvasType("new");
    }
    setShowCanvas(true);

    // साफ clean state so it doesn't reopen on refresh
    window.history.replaceState({}, document.title);
  }
}, [location.state, location.key]);
  const [selectedProvider, setSelectedProvider] = useState([]);
  const [loading, setLoading] = useState(false);
  const lastRequestId = useRef(0);
  const [search, setSearch] = useState("");
  // Which overview tile is currently narrowing Today's Schedule — one of the
  // tiles' weekKey values ("checkedIn", "checkedOut", "noShow", "cancelled",
  // "progress", "completed", "unassigned"), or null for no filter. Clicking
  // a tile now filters this page's own list instead of navigating to
  // DashboardDetailed.jsx.
  const [activeStatusFilter, setActiveStatusFilter] = useState(null);
  // Set true by OpexReminderCard once it loads and finds due/overdue
  // expenses, so Today's/Upcoming shrink from col-lg-6 to col-lg-4 to make
  // room for the reminder card instead of leaving it empty on a quiet day.
  const [hasOpexReminders, setHasOpexReminders] = useState(false);
  // console.log("selectedDate----", selectedDate);
const [showCanvas, setShowCanvas] = useState(false);
const [canvasType, setCanvasType] = useState(""); // 'create', 'new', or 'edit'
const [editGroupId, setEditGroupId] = useState(null);
 const totalRevenue = fullData.reduce((sum, item) => {
   return sum + Number(item?.total || 0);
 }, 0).toFixed(1);
 
   useEffect(() => {
     let today = new Date();
     let d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
     // console.log("d1---", d1);
     let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
     // console.log("d2--", d2);
     setSelectedDate(d2);
     getBookingByDate();
     getWeekOverview();
     refreshVendorData();
   }, []);

   useEffect(() => {
     getBookingByDate();
     getWeekOverview();
   }, [selectedDate, rangeEnd]);

   const getBookingByDate = async () => {
     try {
       // console.log("selectedDate--", selectedDate);
       if (!selectedDate) return;
       setLoading(true);
       let currentId = ++lastRequestId.current;
       // Single date -> the existing ?date= endpoint. A picked range ->
       // the same startDate/endDate endpoint getWeekOverview already uses
       // below, so every tile/donut/list downstream (all built off this
       // fetch) automatically reflects the whole range instead of one day.
       const bookingUrl = isRange
         ? `get_ezp_booking?startDate=${rangeStartDate}&&endDate=${rangeEndDate}`
         : `get_ezp_booking?date=${selectedDate}`;
        const [get_booking_data, crewRes] = await Promise.all([
       apicall.get(bookingUrl),
       apicall.get(`get_vendor_crews`)
     ]);
 
 
       if (currentId !== lastRequestId.current) return;
 
       // console.log("get_booking_data-----", get_booking_data);
       let allData = get_booking_data?.data;
       let a1 = allData.filter((ele) => ele?.booking_status !== "Cancelled");
       setInitialData(a1);
        setAllCrews(crewRes?.data || []);
     fetchAvailability(crewRes?.data || []);

     // Re-apply the currently selected crew/doctor filter (if any) to the
     // newly fetched date's data — otherwise navigating dates via the
     // calendar wiped the filter back to "show everyone" every time.
     if (selectedProvider.length) {
       const names = selectedProvider.map((p) => p.name.trim());

       const filteredBookings = a1.filter((item) => {
         const providerList = item.provider_names
           ? item.provider_names.split(",").map((p) => p.trim())
           : [];
         return providerList.some((p) => names.includes(p));
       });

       const filteredCrewsList = (crewRes?.data || []).filter((crew) =>
         names.includes(crew.first_name)
       );

       setFullData(filteredBookings);
       setFilteredCrews(filteredCrewsList);
     } else {
       setFullData(a1);
       setFilteredCrews(crewRes?.data || []);
     }
       // Matched by status NAME, not a hardcoded id — the numeric booking
       // status ids are industry-scoped (ezp_booking_status) and this
       // codebase already has two conflicting ids for "Checked In" (5 vs
       // 11) in different places, so the name string (already resolved
       // server-side via the bs.name join) is the only reliable match.
       // Stripped down to letters only (not just spaces/hyphens) so both
       // "Check Out" -> "checkout" and "Checked Out" -> "checkedout" are
       // covered — checking only one variant was why the Check Out tile
       // stayed at 0 (the actual saved name didn't contain "checkedout").
       // Reuses computeCounts (below) instead of a separate hand-rolled
       // tally — it already covers every field this day view needs
       // (including booked/unassigned/revenue, which the old inline object
       // here didn't have), and keeps the day-level counts and the
       // rolling-week counts computed by the exact same rules so they never
       // drift apart.
       setOrderCounts(computeCounts(allData));
       setLoading(false);
     //    if (a1?.length === 0) {
     //   await getAllCrews();  
     // } else {
     //   setAllCrews([]);  
     // }
     } catch (e) {
       console.log("err----", e);
     }
   };

   // Same status-name matching used by getBookingByDate's day-level counts
   // above — factored out so the rolling-week fetch below (current week +
   // previous week, for the tiles' trend badges) can reuse it instead of
   // duplicating the matching logic a second/third time.
   const computeCounts = (rows) => ({
     total: rows?.length || 0,
     progress: rows?.filter(
       (item) =>
         item.booking_status === "In Progress" ||
         (isClinicService && Number(item.status) === 5)
     ).length || 0,
     completed: rows?.filter((item) => item.booking_status === "Completed").length || 0,
     cancelled: rows?.filter((item) => {
       const n = normStatus(item.booking_status);
       return n === "cancelled" || n === "canceled";
     }).length || 0,
     booked: rows?.filter((item) => item.booking_status === "Booked").length || 0,
     checkedIn: rows?.filter((item) => {
       const n = normStatus(item.booking_status);
       return n.includes("checkin") || n.includes("checkedin");
     }).length || 0,
     checkedOut: rows?.filter((item) => {
       const n = normStatus(item.booking_status);
       return n.includes("checkout") || n.includes("checkedout") || n === "completed";
     }).length || 0,
     noShow: rows?.filter((item) => normStatus(item.booking_status).includes("noshow")).length || 0,
     unassigned: rows?.filter((item) => {
       const raw = item?.provider_ids;
       if (!raw || raw === "null" || raw === "undefined") return true;
       return raw.split(",").map((p) => p.trim()).filter(Boolean).length === 0;
     }).length || 0,
     // item.total, not total_paid_amount — Cash and online bookings both
     // count toward overall revenue, regardless of payment status.
     revenue: rows?.reduce((sum, item) => sum + Number(item?.total || 0), 0) || 0,
   });

   const getMondayOf = (dateStr) => {
     const d = dateStr ? new Date(dateStr) : new Date();
     const day = d.getDay();
     const diff = d.getDate() - day + (day === 0 ? -6 : 1);
     const monday = new Date(d);
     monday.setDate(diff);
     monday.setHours(0, 0, 0, 0);
     return monday;
   };
   const fmtYMD = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

   // Rolling-week overview: current week (Mon-Sun of selectedDate) + the
   // same range the week before, fetched via get_ezp_booking's existing
   // startDate/endDate support (already used by DashboardDetailed.jsx) —
   // powers the tiles' trend badges, the revenue chart, the status donut,
   // and Upcoming Bookings. Separate from getBookingByDate above, which
   // Today's Schedule and the calendar still read exactly as before.
   const getWeekOverview = async () => {
     try {
       // A picked range replaces the Mon-Sun week entirely — tiles/donut
       // already come from getBookingByDate's own range-aware fetch above,
       // so this only needs to supply the revenue trend (one point per day
       // actually in the range, not a fixed 7-day week) and can skip the
       // "vs last week" comparison, which doesn't mean anything against an
       // arbitrary custom range.
       if (isRange) {
         const rangeRes = await apicall.get(
           `get_ezp_booking?startDate=${rangeStartDate}&&endDate=${rangeEndDate}`
         );
         const rangeRows = rangeRes?.data || [];

         setWeekCounts(computeCounts(rangeRows));
         setPrevWeekCounts(emptyWeekCounts);

         const byDay = {};
         const cursor = new Date(rangeStartDate);
         const rangeEndObj = new Date(rangeEndDate);
         while (cursor <= rangeEndObj) {
           byDay[fmtYMD(cursor)] = 0;
           cursor.setDate(cursor.getDate() + 1);
         }
         rangeRows
           .filter((r) => normStatus(r.booking_status) !== "cancelled")
           .forEach((r) => {
             const key = String(r.service_date || "").slice(0, 10);
             if (key in byDay) byDay[key] += Number(r.total || 0);
           });
         setRevenueByDay(
           Object.entries(byDay).map(([dateKey, revenue]) => ({
             day: new Date(dateKey + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "2-digit" }),
             revenue,
           }))
         );

         // "Upcoming" (dates after today) doesn't apply once the user is
         // explicitly browsing a custom range — that range's own bookings
         // already show in Today's Schedule (see the JSX below, which also
         // hides this card entirely while isRange is true).
         setUpcomingRows([]);
         return;
       }

       const monday = getMondayOf(selectedDate);
       const sunday = new Date(monday);
       sunday.setDate(sunday.getDate() + 6);
       const prevMonday = new Date(monday);
       prevMonday.setDate(prevMonday.getDate() - 7);
       const prevSunday = new Date(monday);
       prevSunday.setDate(prevSunday.getDate() - 1);

       // Upcoming is always the next 7 days from today (tomorrow .. today+7),
       // not the rest of the selected week - on a Friday that was only Sat/Sun.
       const upcomingStart = new Date();
       upcomingStart.setDate(upcomingStart.getDate() + 1);
       const upcomingEnd = new Date();
       upcomingEnd.setDate(upcomingEnd.getDate() + 7);

       const [curRes, prevRes, upcomingRes] = await Promise.all([
         apicall.get(`get_ezp_booking?startDate=${fmtYMD(monday)}&&endDate=${fmtYMD(sunday)}`),
         apicall.get(`get_ezp_booking?startDate=${fmtYMD(prevMonday)}&&endDate=${fmtYMD(prevSunday)}`),
         apicall.get(`get_ezp_booking?startDate=${fmtYMD(upcomingStart)}&&endDate=${fmtYMD(upcomingEnd)}`),
       ]);

       const curRows = curRes?.data || [];
       const prevRows = prevRes?.data || [];
       const upcomingSource = upcomingRes?.data || [];

       setWeekCounts(computeCounts(curRows));
       setPrevWeekCounts(computeCounts(prevRows));

       // Revenue Overview shows the Mon-Sun week as context on the x-axis,
       // but only plots real revenue on whichever date is selected — every
       // other day in the week is left at 0, so the line reads as "0 up to
       // the selected day's amount" instead of a full week trend. curRows
       // (fetched above for weekCounts' trend badges) already covers the
       // whole week, so no separate fetch is needed. Cancelled bookings
       // excluded; sums item.total so Cash and online both count.
       const byDay = {};
       for (let i = 0; i < 7; i++) {
         const d = new Date(monday);
         d.setDate(d.getDate() + i);
         byDay[fmtYMD(d)] = 0;
       }
       if (selectedDate in byDay) {
         byDay[selectedDate] = curRows
           .filter((r) => normStatus(r.booking_status) !== "cancelled")
           .filter((r) => String(r.service_date || "").slice(0, 10) === selectedDate)
           .reduce((sum, r) => sum + Number(r.total || 0), 0);
       }
       setRevenueByDay(
         Object.entries(byDay).map(([dateKey, revenue]) => ({
           day: new Date(dateKey + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "2-digit" }),
           revenue,
         }))
       );

       // Upcoming: the next 7 days, chronological, next 5.
       const upcoming = upcomingSource
         .filter((r) => normStatus(r.booking_status) !== "cancelled")
         .sort((a, b) => (a.service_date + a.service_time).localeCompare(b.service_date + b.service_time))
         .slice(0, 5)
         .map((r) => ({
           id: r.booking_id || r.group_id,
           name: r.user_name || r.dependent_name || "-",
           subtitle: [r.service_name, r.service_offering_name].filter(Boolean).join(" · "),
           timeLabel: r.service_time ? new Date(`2000-01-01T${r.service_time}`).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "",
           dateLabel: new Date(r.service_date + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" }),
           // Same status pill Today's Schedule shows, using the same
           // getStatusName/getStatusColors the calendar events use.
           statusLabel: getStatusName(r.booking_status),
           statusColors: getStatusColors(r.booking_status),
           onClick: () => handleAppointmentClick({ details: r }, r.service_date?.slice(0, 10)),
         }));
       setUpcomingRows(upcoming);
     } catch (e) {
       console.log("getWeekOverview err----", e);
     }
   };

   // Keyed by status NAME (booking_status), not the numeric status id — the
   // numeric ids are industry-scoped and this codebase already has
   // conflicting ids for the same status in different places (see the
   // "Checked In" 5-vs-11 note above), so the id alone isn't a reliable
   // lookup. Uses the same STATUS_COLOR_RULES the overview tiles' colors
   // are drawn from, so a booking's calendar color always matches its tile.
   const getStatusColors = (statusName) => {
     const n = normStatus(statusName);
     const rule = STATUS_COLOR_RULES.find((r) => r.test(n));
     return rule ? rule.colors : DEFAULT_STATUS_COLORS;
   };

   const getStatusName = (statusName) => statusName || "Booked";

   // Mirrors the same predicates computeCounts uses to tally each tile, so
   // clicking a tile shows exactly the bookings that made up its number.
   const matchesTileFilter = (item, key) => {
     if (!key || key === "total") return true;
     const n = normStatus(item?.booking_status);
     switch (key) {
       case "checkedIn":
         return n.includes("checkin") || n.includes("checkedin");
       case "checkedOut":
         return n.includes("checkout") || n.includes("checkedout") || n === "completed";
       case "noShow":
         return n.includes("noshow");
       case "cancelled":
         return n === "cancelled" || n === "canceled";
       case "progress":
         return item?.booking_status === "In Progress" || (isClinicService && Number(item?.status) === 5);
       case "completed":
         return item?.booking_status === "Completed";
       case "booked":
         return item?.booking_status === "Booked";
       case "unassigned": {
         const raw = item?.provider_ids;
         if (!raw || raw === "null" || raw === "undefined") return true;
         return raw.split(",").map((p) => p.trim()).filter(Boolean).length === 0;
       }
       default:
         return true;
     }
   };

   const toFullCalendarDate = (bookingDate, bookingTime) => {
     return `${bookingDate}T${bookingTime}:00`; // Assuming bookingTime is in 'HH:mm' format
   };
 
 const calenderData = fullData?.flatMap((item) => {
   const colors = getStatusColors(item?.booking_status);
 
   const start = toFullCalendarDate(item.service_date, item.service_time);
 
   const providerNames = item.provider_names
     ? item.provider_names.split(",").map((p) => p.trim())
     : [];
 
   const providerIds = item.provider_ids
     ? item.provider_ids.split(",").map((p) => p.trim())
     : [];
 
   const timePerPerson =
     (Number(item?.total_time_required) + Number(item?.total_buffer)) /
     (providerIds.length || 1);
 
   // Full date+time (rolls into the next day for jobs running past midnight)
   // rather than a clock-only "HH:mm", which wrapped to before the start.
   const end =
     addMinutesToDateTime(item.service_date, item.service_time, timePerPerson) ||
     start;

   item.status_name = getStatusName(item.booking_status);

   if (!providerIds.length) {
     return [
       {
         id: `${item.booking_id}-unassigned`,
         title: "Unassigned",
         resourceId: "unassigned",
         start,
         end,
         backgroundColor: colors.bgColor,
         borderColor: colors.borderColor,
         textColor: colors.textColor,
         extendedProps: {
           ...item,
           provider_name: "Unassigned",
           provider_id: null,
         },
       },
     ];
   }

   return providerIds
     .map((id, index) => {
       if (!id) return null; // ❗ prevent broken entries

       return {
         id: `${item.booking_id}-${id}`, // ⭐ unique event id
         title: providerNames[index] || "Crew",
         resourceId: id, // ✅ ALWAYS use ID only
         start,
         end,
         backgroundColor: colors.bgColor,
         borderColor: colors.borderColor,
         textColor: colors.textColor,
         extendedProps: {
           ...item,
           provider_name: providerNames[index],
           provider_id: id,
         },
       };
     })
     .filter(Boolean);
 });

 const unassignedCount = fullData.filter((item) => {
   const raw = item?.provider_ids;
   if (!raw || raw === "null" || raw === "undefined") return true;
   const providers = raw.split(",").map((p) => p.trim()).filter(Boolean);
   return providers.length === 0;
 }).length;
 
 //   const calenderData = fullData?.flatMap((item) => {
 
 //       const providerNames = item.provider_names
 //   ? item.provider_names.split(",").map((p) => p.trim())
 //   : [];
 
 // const providerIds = item.provider_ids
 //   ? item.provider_ids.split(",").map((p) => p.trim())
 //   : [];
 //     const colors = getStatusColors(item?.status);
 
 //     const start = toFullCalendarDate(item.service_date, item.service_time);
 
 //     const providerList = item.provider_names
 //       ? item.provider_names.split(",").map((p) => p.trim())
 //       : [];
 
 //     const timePerPerson =
 //       (Number(item?.total_time_required) + Number(item?.total_buffer)) /
 //       (providerList.length || 1);
 
 //     const endTime = addMinutes(item?.service_time, timePerPerson);
 //     const end = toFullCalendarDate(item.service_date, endTime);
 
 //     item.status_name = getStatusName(item.status);
 
 //     //  CREATE ONE EVENT PER PERSON
 //     // return providerList.map((provider) => ({
 //     //   title: provider, //  single name
 //     //   resourceId: provider, //  single resource
 //     //   start,
 //     //   end,
 //     //   backgroundColor: colors.bgColor,
 //     //   borderColor: colors.borderColor,
 //     //   textColor: colors.textColor,
 //     //   extendedProps: {
 //     //     ...item,
 //     //     provider_name: provider, //  add explicitly
 //     //   },
 //     //   className: `status-${item?.status || "default"}`,
 //     // }));
 //     return providerNames.map((provider, index) => ({
 //   title: provider,
 //   resourceId: providerIds[index],   // 🔥 USE ID NOT NAME
 //   start,
 //   end,
 //   backgroundColor: colors.bgColor,
 //   borderColor: colors.borderColor,
 //   textColor: colors.textColor,
 //   extendedProps: {
 //     ...item,
 //     provider_name: provider,
 //     provider_id: providerIds[index],
 //   },
 // }));
 //   });
 console.log(calenderData,"calenderData")
 const fetchAvailability = async (crews) => {
   try {
     const results = await Promise.all(
       crews.map(async (crew) => {
         const res = await apicall.get(
           `get_availability/${crew.user_id}`
         );
         return {
           user_id: crew.user_id,
           data: res?.data,
         };
       })
     );
 
     const map = {};
     results.forEach((item) => {
       map[item.user_id] = item.data;
     });
 
     setAvailabilityMap(map);
   } catch (e) {
     console.log("availability error", e);
   }
 };
 const generateHalfHourSlots = (availability, selectedDate) => {
   if (!availability) return [];
 
   const { shifts } = availability;
   const day = new Date(selectedDate).getDay();
 
   const dayShifts = shifts.filter((s) => s.day === day);
 
   let slots = [];
 
   dayShifts.forEach((shift) => {
     if (shift.start_time === "00:00:00") return;
 
     let start = new Date(`${selectedDate}T${shift.start_time}`);
     let end = new Date(`${selectedDate}T${shift.end_time}`);
 
     while (start < end) {
       let next = new Date(start);
       next.setMinutes(next.getMinutes() + 30);
 
       if (next > end) next = end;
 
       slots.push({
         start: new Date(start),
         end: new Date(next),
       });
 
       start = next;
     }
   });
 
   return slots;
 };
 const mapSlotsWithStatus = (slots, jobs) => {
   if (!slots.length) return [];
 
   // Step 1: mark each slot
   const marked = slots.map((slot) => {
    const isBooked = jobs.some(
   (job) =>
     job.start &&
     job.end &&
     slot.start < job.end &&
     slot.end > job.start
 );
 
     return {
       ...slot,
       status: isBooked ? "booked" : "available",
     };
   });
 
   // Step 2: merge continuous slots
   let merged = [];
   let current = { ...marked[0] };
 
   for (let i = 1; i < marked.length; i++) {
     const slot = marked[i];
 
     // same status + continuous time → merge
     if (
       slot.status === current.status &&
       slot.start.getTime() === current.end.getTime()
     ) {
       current.end = slot.end;
     } else {
       merged.push(current);
       current = { ...slot };
     }
   }
 
   merged.push(current);
 
   return merged;
 };
 // filteredCrews comes from get_vendor_crews which returns individual records
 // with user_id / first_name — NOT provider_ids / provider_names. Group by
 // user_id so each crew (doctor, for clinic) appears once even if they
 // service multiple offerings — matches NewDashboard1.jsx's groupedCrews.
 const groupedCrews = Object.values(
   filteredCrews.reduce((acc, crew) => {
     const id = String(crew.user_id || "").trim();
     if (!id) return acc;

     if (!acc[id]) {
       acc[id] = {
         user_id: id,
         first_name: crew.first_name || "Unknown",
         serviceNames: new Set(),
       };
     }

     const serviceData = crew.service_name || crew.service_offering_name;
     if (serviceData) {
       if (Array.isArray(serviceData)) {
         serviceData.forEach((s) => acc[id].serviceNames.add(s));
       } else {
         acc[id].serviceNames.add(serviceData);
       }
     }

     return acc;
   }, {})
 );
 const crewSchedule = groupedCrews.map((crew) => {
   const crewName = crew.first_name;
 
 const crewBookings = calenderData.filter(
   (event) => String(event.resourceId).trim() === String(crew.user_id).trim()
 );
   const jobs = crewBookings
     .map((event) => ({
       title:
         event.extendedProps?.service_name ||
         event.extendedProps?.service_offering_name ||
         "Service",
       category:
         event.extendedProps?.service_type_name ||
         event.extendedProps?.service_offering_name ||
         "",
       start: new Date(event.start),
       end: new Date(event.end),
       data: event.extendedProps,
     }))
     .sort((a, b) => a.start - b.start);
 
   const allServices = new Set([...crew.serviceNames]);
 
   jobs.forEach((job) => {
     if (job.title) {
       allServices.add(job.title);
     }
   });
 
   const availability = availabilityMap[crew.user_id];
 
   const slots = generateHalfHourSlots(
     availability,
     selectedDate
   );
 
   const slotsWithStatus = mapSlotsWithStatus(slots, jobs);
 
   const bookedSlots = slotsWithStatus.filter(
     (s) => s.status === "booked"
   );
 
   const availableSlots = slotsWithStatus.filter(
     (s) => s.status === "available"
   );
 
   return {
     crewName,
     serviceName: [...allServices].join(", ") || "Service",
     jobs,
     slots: slotsWithStatus,
     bookedSlots,
     availableSlots,
   };
 });
 const getMinutes = (start, end) => {
   const s = new Date(start).getTime();
   const e = new Date(end).getTime();
 
   if (isNaN(s) || isNaN(e)) return 0;
 
   return (e - s) / (1000 * 60);
 };
 let totalBookedMinutes = 0;
 
 crewSchedule.forEach((crew) => {
   const intervals = crew.jobs
     .map((job) => ({
       start: new Date(job.start).getTime(),
       end: new Date(job.end).getTime(),
     }))
     .sort((a, b) => a.start - b.start);
 
   let merged = [];
 
   intervals.forEach((curr) => {
     if (!merged.length || merged[merged.length - 1].end < curr.start) {
       merged.push(curr);
     } else {
       merged[merged.length - 1].end = Math.max(
         merged[merged.length - 1].end,
         curr.end
       );
     }
   });
 
   const bookedMinutes = merged.reduce(
     (sum, slot) => sum + Math.max(0, (slot.end - slot.start) / (1000 * 60)),
     0
   );
 
   totalBookedMinutes += bookedMinutes;
 });
 const bookedHours = (totalBookedMinutes / 60).toFixed(1);
 
 const formatTime = (date) =>
   date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
 
 const minutesToHours = (mins) => (mins / 60).toFixed(1);
 
   const result = calenderData.reduce(
     (acc, item) => {
       return {
         minStart: item.start < acc.minStart ? item.start : acc.minStart,
         maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
       };
     },
     {
       minStart: calenderData[0]?.start,
       maxEnd: calenderData[0]?.end,
     }
   );
 
   let min1 = result?.minStart?.split("T")[1];
   let max1 = result?.maxEnd?.split("T")[1];
 
   let minTime = "08:00:00";
   min1 = min1 < minTime ? min1 : "08:00:00";
 
   let maxTime = "20:00:00";
   max1 = max1 > maxTime ? max1 : "20:00:00";
 
   min1 = `2026-04-09T${min1}`;
   max1 = `2026-04-09T${max1}`;
 
   const handleAppointmentClick = (data, currentDate) => {
     // console.log("data, currentDate--", data, currentDate);
     let group_id = data?.details?.display_booking_id || 1;
     // console.log("display_booking_id---", data?.details?.display_booking_id);
     // Open the same sidepanel used for "New Appointment" instead of navigating
     // to the generic (non-clinic) Bookings.jsx edit page.
     setEditGroupId(group_id);
     setCanvasType("edit");
     setShowCanvas(true);
     // fetchDoctorAvailability(data?.details?.doctor_id, currentDate);
     // fetchDoctorHolidays(data?.details?.doctor_id);
   };
 
   const datesSet = (dateInfo) => {
     try {
 
       // console.log("adteIfo---", dateInfo);
       let d1 = dateInfo.startStr?.split("T")?.[0];
       setSelectedDate(d1);
 
       if (![0, 1].includes(flagCount.current)) {
         // console.log("adteIfo---", dateInfo);
         let d1 = dateInfo.startStr?.split("T")?.[0];
         // console.log("d1-----", d1);
         setSelectedDate(d1);
         // setDateSelect(d1);
         // getWorkerAvailableSlots(d1);
       }
       flagCount.current += 1;
     } catch (e) {
       console.log("err---", e);
     }
   };
 
   const formatDateDisplay = (date) => {
     if (!date) return "";
 
     const d = new Date(date);
     const months = [
       "Jan",
       "Feb",
       "Mar",
       "Apr",
       "May",
       "Jun",
       "Jul",
       "Aug",
       "Sep",
       "Oct",
       "Nov",
       "Dec",
     ];
 
     return `${
       months[d.getUTCMonth()]
     } ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
   };
 
   const detailedDashBoard = () => {
     // console.log("detailedDashBoard");
     navigate(`/dashboard/${selectedDate}`);
   };
 
   // const allProvider = [
   //   ...new Map(
   //     initialData?.map((item) => [
   //       item.provider_names,
   //       { name: item.provider_names },
   //     ])
   //   ).values(),
   // ];
 
 const allProvider = [
   ...new Set([
     ...(initialData?.flatMap((item) =>
       item.provider_names?.split(",").map((n) => n.trim())
     ) || []),
 
     ...(allCrews?.map((crew) => crew.first_name?.trim()) || []),
   ]),
 ]
   .filter(Boolean)
   .sort()
   .map((name) => ({ name }));
 
   // console.log("allProvider---", allProvider);
   const [dates, setDates] = useState([]);
 
   const stripRef = useRef(null);
   const activeDateRef = useRef(null);
   useEffect(() => {
     const today = new Date();
     today.setHours(0, 0, 0, 0);
 
     // Initial window: 30 days past + 30 days future
     const initialDates = [];
     for (let i = -30; i <= 30; i++) {
       const date = new Date(today);
       date.setDate(today.getDate() + i);
       initialDates.push(date);
     }
     setDates(initialDates);
   }, []);
   useEffect(() => {
     if (activeDateRef.current) {
       activeDateRef.current.scrollIntoView({
         behavior: "smooth",
         inline: "center",
         block: "nearest",
       });
     }
   }, [selectedDate, dates]);
   // load more past dates when user scrolls left
   const handleScroll = () => {
     if (!stripRef.current) return;
 
     // if scroll is near left edge
     if (stripRef.current.scrollLeft < 50) {
       const firstDate = dates[0];
       const newPastDates = [];
       for (let i = 1; i <= 30; i++) {
         const date = new Date(firstDate);
         date.setDate(firstDate.getDate() - i);
         newPastDates.unshift(date);
       }
       setDates((prev) => [...newPastDates, ...prev]);
 
       // maintain scroll position after prepending
       stripRef.current.scrollLeft += 30 * 60; // approximate width of 30 date boxes
     }
   };
   // const onProviderSearch = (providers) => {
   //   setSelectedProvider(providers);
 
   //   if (!providers.length) {
   //     setFullData(initialData);
   //     return;
   //   }
 
   //   const names = providers.map((p) => p.name);
 
   //   const filtered = initialData.filter((item) => {
   //     if (item.provider_names?.includes(",")) {
   //       let p1 = item.provider_names.split(",");
   //       for (let i of p1) {
   //         if (names.includes(i.trim())) {
   //           return true;
   //         }
   //       }
   //     } else {
   //       return names.includes(item.provider_names);
   //     }
   //   });
 
   //   setFullData(filtered);
   // };
 const onProviderSearch = (providers) => {
   setSelectedProvider(providers);
 
   if (!providers.length) {
     setFullData(initialData);
     setFilteredCrews(allCrews);
     return;
   }
 
   const names = providers.map((p) => p.name.trim());
 
   const filteredBookings = initialData.filter((item) => {
     const providerList = item.provider_names
       ? item.provider_names.split(",").map((p) => p.trim())
       : [];
 
     return providerList.some((p) => names.includes(p));
   });
 
   const filteredCrewsList = allCrews.filter((crew) =>
     names.includes(crew.first_name)
   );
 
   setFullData(filteredBookings);
   setFilteredCrews(filteredCrewsList);
 };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <DashboardHeader
            userName={vendor?.business_name || "there"}
            subtitle={`Here's what's happening with your ${isClinicService ? "clinic" : "business"} today.`}
          />

          {/* ================= OVERVIEW HEADER ================= */}
          <div className="d-flex justify-content-between align-items-center mb-3 pt-0">
            <div>
              <h5
                className="mb-0"
                style={{ fontSize: "16px", fontWeight: "700", color: "#1e293b", letterSpacing: "-0.01em" }}
              >
                Overview
                {selectedDate && (
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "400",
                      marginLeft: "8px",
                      color: "#94a3b8",
                    }}
                  >
                    ({isRange ? `${formatDateDisplay(selectedDate)} – ${formatDateDisplay(rangeEndDate)}` : formatDateDisplay(selectedDate)})
                  </span>
                )}
              </h5>
            </div>

            <div
              className="d-flex align-items-center gap-2"
              style={{ position: "relative" }}
            >
              <span style={{ fontSize: "12px", color: "#94a3b8", fontWeight: "500", letterSpacing: "0.03em", textTransform: "uppercase" }}>
                Filter by:
              </span>

              <div
                ref={dateFilterRef}
                style={{ position: "relative" }}
                data-tour="dashboard-date"
              >
                <button
                  className="btn d-flex align-items-center justify-content-center"
                  style={{
                    width: "34px",
                    height: "34px",
                    padding: 0,
                    border: "1px solid #E3EBF8",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    color: "#64748b",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen(!open);
                  }}
                >
                  <FaRegCalendarAlt size={14} />
                </button>

                {open && (
                  <div
                    style={{
                      position: "absolute",
                      top: "40px",
                      right: 0,
                      zIndex: 9999,
                    }}
                  >
                    <DatePicker
                      selectsRange
                      startDate={selectedDate ? new Date(selectedDate) : null}
                      endDate={rangeEnd ? new Date(rangeEnd) : null}
                      // react-datepicker hands back raw JS Date objects —
                      // every other place selectedDate is set (the initial
                      // load, the mobile date strip) uses a "YYYY-MM-DD"
                      // string, and get_ezp_booking?date=${selectedDate}
                      // needs that same string, so always format through
                      // fmtYMD. selectsRange fires [start, null] on the
                      // first click and [start, end] on the second — a
                      // single-date pick is just clicking the same day
                      // twice (start === end), which isRange already
                      // treats as "no range".
                      onChange={(dates) => {
                        const [start, end] = dates;
                        if (start) setSelectedDate(fmtYMD(start));
                        setRangeEnd(end ? fmtYMD(end) : null);
                        if (start && end) setOpen(false);
                      }}
                      inline
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ================= SEARCH + NEW BOOKING (DESKTOP ONLY) ================= */}
          <div className="desktop-only d-flex justify-content-between align-items-center">
            <div className="d-flex gap-3 align-items-center">
              <div className="position-relative">
                {/* <input
                  type="text"
                  value={search}
                  className="form-control"
                  placeholder="Search"
                  onChange={(e) => onProviderSearch(e.target.value)}
                  style={{
                    height: "40px",
                    width: "240px",
                    backgroundColor: "#F8F9FA",
                    border: "1px solid #E3EBF8",
                    borderRadius: "8px",
                    paddingLeft: "36px",
                    fontSize: "14px",
                  }}
                />
                <FaSearch
                  className="position-absolute text-muted"
                  style={{ left: "12px", top: "12px" }}
                /> */}
             <div
                             style={{
                               width: "240px",
                               display: "flex",
                               alignItems: "center",
                               gap: "6px",
                             }}
                             data-tour="dashboard-provider-filter"
                           >

                             <MultiSelect
                               value={selectedProvider}
                               onChange={(e) => onProviderSearch(e.value)}
                               options={allProvider}
                               optionLabel="name"
                               filter
                               placeholder="Search Doctor"
                               maxSelectedLabels={2}
                               style={{
                                 flex: 1,
                                 height: "40px",
                                 backgroundColor: "#F8F9FA",
                                 border: "1px solid #E3EBF8",
                                 borderRadius: "8px",
                                 fontSize: "14px",
                               }}
                             />
           
                             {selectedProvider.length > 0 && (
                               <button
             onClick={() => {
               setSelectedProvider([]);
               setFullData(initialData);
               // Restore the full list too - bookings are back to everyone's,
               // so the utilization tile must cover every doctor again.
               setFilteredCrews(allCrews);
             }}
             className="btn btn-outline-danger"
             style={{ fontSize: "13px", fontWeight: "600", borderRadius: "8px", padding: "6px 12px" }}
           >
             Clear
           </button>
                             )}
                           </div>
              </div>
            </div>

            <div>
              <button
  data-tour="dashboard-new-appointment"
  onClick={() => {
    setEditGroupId(null);
    setCanvasType("new");
    setShowCanvas(true);
  }}
  className="btn btn-danger new-appt-btn"
>
   New Appointment
</button>
            </div>
          </div>

          {/* ================= OVERVIEW TILES ================= */}
          {(() => {
            const weekStart = getMondayOf(selectedDate);
            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekEnd.getDate() + 6);
            const prevStart = new Date(weekStart);
            prevStart.setDate(prevStart.getDate() - 7);
            const prevEnd = new Date(weekStart);
            prevEnd.setDate(prevEnd.getDate() - 1);
            const fmt = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
            // const vsLabel = `vs ${fmt(prevStart)} - ${fmt(prevEnd)}`;
            const trendFor = (key) => {
              const cur = weekCounts?.[key] ?? 0;
              const prev = prevWeekCounts?.[key] ?? 0;
              if (!prev) return null;
              return ((cur - prev) / prev) * 100;
            };

            const tilesCurrency = localStorage.getItem("currency") || "AED";
            const tiles = isClinicService
              ? [
                  { label: "Today's Appointment", icon: <LuClock style={{ fontSize: "20px", color: "#037FE8" }} />, value: orderCounts?.total, color: "#037FE8", weekKey: "total" },
                  { label: "Check In", icon: <LuClipboardCheck style={{ fontSize: "20px", color: "#CCCC00" }} />, value: orderCounts?.checkedIn, color: "#CCCC00", weekKey: "checkedIn" },
                  { label: "Check Out", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#28A745" }} />, value: orderCounts?.checkedOut, color: "#28A745", weekKey: "checkedOut" },
                  { label: "No Show", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#FD7E14" }} />, value: orderCounts?.noShow, color: "#FD7E14", weekKey: "noShow" },
                  { label: "Cancelled", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#FF0000" }} />, value: orderCounts?.cancelled, color: "#FF0000", weekKey: "cancelled" },
                  { label: "Revenue", icon: <LuClipboardCheck style={{ fontSize: "20px", color: "#28A745" }} />, value: tilesCurrency ? `${tilesCurrency} ${totalRevenue}` : `${totalRevenue}`, color: "#28A745", weekKey: "revenue" },
                  { label: "Doctor Utilization", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#FF8C00" }} />, value: `${bookedHours}hrs`, color: "#FF8C00", weekKey: null },
                ]
              : [
                  { label: "Today's Appointment", icon: <LuClock style={{ fontSize: "20px", color: "#037FE8" }} />, value: orderCounts?.total, color: "#037FE8", weekKey: "total" },
                  { label: "CheckedIn", icon: <LuClipboardCheck style={{ fontSize: "20px", color: "#CCCC00" }} />, value: orderCounts?.completed, color: "#CCCC00", weekKey: "completed" },
                  { label: "Progress", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#92007E" }} />, value: orderCounts?.progress, color: "#92007E", weekKey: "progress" },
                  { label: "Unassigned", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#6C757D" }} />, value: unassignedCount, color: "#6C757D", weekKey: "unassigned" },
                  { label: "Cancelled", icon: <HiOutlineUsers style={{ fontSize: "20px", color: "#FF0000" }} />, value: orderCounts?.cancelled, color: "#FF0000", weekKey: "cancelled" },
                ];

            // Layout (phone summary / tablet columns / desktop row) lives in
            // KpiTileGrid; what each tile means and does stays here.
            return (
              <KpiTileGrid
                tiles={tiles.map((item) => ({
                      key: item.weekKey || item.label,
                      icon: item.icon,
                      label: item.label,
                      value: item.value,
                      color: item.color,
                      weekKey: item.weekKey,
                      // trendPct={trendFor(item.weekKey)}
                      // vsLabel={vsLabel}
                      active: item.weekKey === "revenue" ? false : item.weekKey === "total" ? !activeStatusFilter : item.weekKey ? activeStatusFilter === item.weekKey : false,
                      // Revenue and Doctor Utilization are plain stats, not
                      // booking-status filters or navigation shortcuts — no
                      // onClick at all makes KpiTileCard render them
                      // non-interactive (cursor: default, no click handler).
                      onClick: item.weekKey === "revenue" || !item.weekKey ? undefined : () => {
                        if (item.weekKey === "total") {
                          // A filter is active (Check In/Out/etc. clicked
                          // earlier) — first click on Today's Appointment
                          // just clears it back to the real, unfiltered
                          // today's data. Only once it's already showing
                          // that (no filter left to clear) does clicking it
                          // again go to the detailed view, like before.
                          if (activeStatusFilter) {
                            setActiveStatusFilter(null);
                          } else {
                            detailedDashBoard();
                          }
                          return;
                        }
                        setActiveStatusFilter((prev) => (prev === item.weekKey ? null : item.weekKey));
                      },
                }))}
              />
            );
          })()}

          {/* ================= REVENUE / STATUS DONUT / QUICK ACTIONS ================= */}
          {(() => {
            // Scoped to the selected day (orderCounts), not the whole
            // Mon-Sun week (weekCounts) — weekCounts is only for the tiles'
            // "vs last week" trend badges. Using it here meant picking a
            // single date still summed every booking status across the
            // entire week (e.g. today's 2 bookings + another day's booking
            // both showing up), instead of just that day's.
            const donutSegments = isClinicService
              ? [
                 { label: "Booked", count: orderCounts.booked, color: "#92007E" },
                  { label: "Check In", count: orderCounts.checkedIn, color: "#CCCC00" },
                  { label: "Check Out", count: orderCounts.checkedOut, color: "#28A745" },
                  { label: "No Show", count: orderCounts.noShow, color: "#FD7E14" },
                  { label: "Cancelled", count: orderCounts.cancelled, color: "#FF0000" },
                ]
              : [
                  { label: "Completed", count: orderCounts.completed, color: "#CCCC00" },
                  { label: "In Progress", count: orderCounts.progress, color: "#92007E" },
                  { label: "Cancelled", count: orderCounts.cancelled, color: "#FF0000" },
                  { label: "Unassigned", count: orderCounts.unassigned, color: "#6C757D" },
                ];
            const currency = localStorage.getItem("currency") || "AED";

            return (
              <div className="row g-3 mb-4 desktop-only">
            <div className="col-12 col-lg-5">
  <div
    style={{
      borderRadius: "14px",
      border: "1px solid #E3EBF8",
      background: "#fff",
      padding: "16px",
      height: "100%",
      outline: "none",
    }}
  >
    <div
      style={{
        fontSize: "15px",
        fontWeight: 600,
        color: "#111827",
        marginBottom: "8px",
      }}
    >
      Revenue Overview
    </div>

    <RevenueLineChart data={revenueByDay} currency={currency} />
  </div>
</div>
      <div className="col-12 col-lg-4">
  <div
    style={{
      borderRadius: "14px",
      border: "1px solid #E3EBF8",
      background: "#fff",
      padding: "16px",
      height: "100%",
      outline: "none",
    }}
  >
    <div
      style={{
        fontSize: "15px",
        fontWeight: 600,
        color: "#111827",
        marginBottom: "8px",
      }}
    >
      {isClinicService ? "Appointments by Status" : "Bookings by Status"}
    </div>

    <StatusDonutChart
      segments={donutSegments}
      total={orderCounts.total}
    />
  </div>
</div>
                <div className="col-12 col-lg-3">
                  <QuickActionsPanel
                    actions={[
                      {
                        icon: <FaCalendarPlus color="#C0335A" />,
                        iconBg: "#FDEDED",
                        label: `New ${getBookingLabel(industry)}`,
                        sublabel: isClinicService ? "Create a new appointment" : "Create a new service booking",
                        onClick: () => {
                          if (isClinicService) {
                            setEditGroupId(null);
                            setCanvasType("new");
                            setShowCanvas(true);
                          } else {
                            navigate("/vendor_bookings");
                          }
                        },
                      },
                      {
                        icon: <FaUserPlus color="#2563EB" />,
                        iconBg: "#EFF6FF",
                        label: `Add Doctor`,
                        sublabel: `Add new ${crewLabel.toLowerCase()} to your team`,
                        // AddProvider.jsx reads location.state as the full
                        // ezpMyProfile row (vData?.industry) to decide
                        // "Add Doctor" vs "Add Crew" wording — same shape
                        // Providers.jsx's own "Add Doctor" button already
                        // passes (navigate("/providers/add", { state: industry })).
                        onClick: () => navigate("/providers/add", { state: industry }),
                      },
                      {
                        icon: <FaFileInvoiceDollar color="#16A34A" />,
                        iconBg: "#E6F9F0",
                        label: "Create Invoice",
                        sublabel: "Generate new invoice",
                        onClick: () => detailedDashBoard(),
                      },
                    ]}
                  />
                </div>
              </div>
            );
          })()}

          {/* ================= TODAY'S SCHEDULE / UPCOMING ================= */}
          {(() => {
            const todayRows = (calenderData || [])
              .filter((event) => matchesTileFilter(event.extendedProps, activeStatusFilter))
              .slice()
              .sort((a, b) => new Date(a.start) - new Date(b.start))
              .map((event, idx) => {
                const statusName = event.extendedProps?.status_name;
                const colors = getStatusColors(statusName);
                return {
                  id: event.id || idx,
                  name: event.extendedProps?.user_name || event.extendedProps?.dependent_name || "-",
                  subtitle: [event.extendedProps?.service_name, event.extendedProps?.service_offering_name].filter(Boolean).join(" · "),
                  timeLabel: new Date(event.start).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
                  // A picked range spans multiple days, so each row needs
                  // its own date — matches how Upcoming already labels rows.
                  dateLabel: isRange
                    ? new Date(event.start).toLocaleDateString("en-US", { month: "short", day: "numeric" })
                    : undefined,
                  statusLabel: statusName,
                  statusColors: colors,
                  onClick: () => handleAppointmentClick({ details: event.extendedProps }, selectedDate),
                };
              });
            const todayTitle = isRange
              ? (isClinicService ? "Appointments in Range" : "Bookings in Range")
              : (isClinicService ? "Today's Schedule" : "Today's Bookings");
            const todayEmptyLabel = isRange
              ? (isClinicService ? "No appointments in this range" : "No bookings in this range")
              : (isClinicService ? "No appointments today" : "No bookings today");

            return (
              <div className="row g-3 mb-4 desktop-only">
                <div
                  className={
                    isRange ? "col-12 text-danger" : hasOpexReminders ? "col-12 col-lg-4 text-danger" : "col-12 col-lg-6 text-danger"
                  }
                >
                  {activeStatusFilter && (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                      <span style={{ fontSize: "12px", color: "#6B7280" }}>
                        Filtered by: <strong style={{ color: "#111827" }}>{TILE_LABELS[activeStatusFilter] || activeStatusFilter}</strong>
                      </span>
                      <span
                        onClick={() => setActiveStatusFilter(null)}
                        style={{ fontSize: "12px", color: "#d01c4c", fontWeight: 600, cursor: "pointer" }}
                      >
                        Clear ×
                      </span>
                    </div>
                  )}
                  <TodaysScheduleList
                    title={todayTitle}
                    viewAllLabel="View Calendar"
                    onViewAll={() => navigate("/calendar", { state: { selectedDate, selectedProvider } })}
                    rows={todayRows}
                    emptyLabel={activeStatusFilter ? `No ${(TILE_LABELS[activeStatusFilter] || "").toLowerCase()} bookings ${isRange ? "in this range" : "today"}` : todayEmptyLabel}
                  />
                </div>
                {/* "Upcoming" (dates after today) doesn't apply once the
                    user is browsing a custom range — its bookings already
                    show in the range list above. */}
                {!isRange && (
                  <div className={hasOpexReminders ? "col-12 col-lg-4" : "col-12 col-lg-6"}>
                    <TodaysScheduleList
                      title={isClinicService ? "Upcoming Appointments" : "Upcoming Bookings"}
                      viewAllLabel="View Calendar"
                      onViewAll={() => {
                        // "Upcoming" starts the day after today — open the
                        // calendar there instead of on today's date.
                        const tomorrow = new Date();
                        tomorrow.setDate(tomorrow.getDate() + 1);
                        const d1 = tomorrow.toLocaleDateString("en-GB").split(/[\/\-\.]/);
                        const tomorrowDate = `${d1[2]}-${d1[1]}-${d1[0]}`;
                        navigate("/calendar", { state: { selectedDate: tomorrowDate, selectedProvider } });
                      }}
                      rows={upcomingRows}
                      emptyLabel="No upcoming bookings in the next 7 days"
                    />
                  </div>
                )}
                {!isRange && (
                  <div className={hasOpexReminders ? "col-12 col-lg-4" : "d-none"}>
                    <OpexReminderCard onHasReminders={setHasOpexReminders} />
                  </div>
                )}
              </div>
            );
          })()}

          {/* ================= MOBILE TODAY SCHEDULE ================= */}
          <div className="mobile-only-section">
            <h5 style={{ fontSize: "16px", fontWeight: "600" }}>
              Today's Schedule
            </h5>

            {/* Search */}
            <div className="position-relative mt-3">
              <FaSearch className="mobile-search-icon" />
              <input
                type="text"
                className="form-control mobile-search"
                placeholder="Search"
                value={search}
                onChange={(e) => onProviderSearch(e.target.value)}
              />
            </div>

            {/* Horizontal Dates */}
            {/* Horizontal Dates */}
            <div
              className="mobile-date-strip"
              ref={stripRef}
              onScroll={handleScroll}
            >
              {dates.map((date, index) => {
                const formatted = date.toLocaleDateString("en-CA");
                const isActive = formatted === selectedDate;

                return (
                  <div
                    key={index}
                    ref={isActive ? activeDateRef : null}
                    className={`mobile-date-box ${isActive ? "active" : ""}`}
                    onClick={() => {
                      setSelectedDate(formatted);
                      setRangeEnd(null);
                    }}
                  >
                    <div>{date.getDate()}</div>
                    <small>
                      {date.toLocaleString("en-US", { month: "short" })}
                    </small>
                  </div>
                );
              })}
            </div>

            {/* Booking List */}
            {calenderData?.length === 0 && (
              <div className="text-center text-muted mt-3">
                No Appointments for this day
              </div>
            )}

            {calenderData?.map((event, index) => {
              const start = new Date(event.start);
              const end = new Date(event.end);

              const formatTime = (date) =>
                date.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });

              const statusName = event.extendedProps?.status_name;
              const status = event.extendedProps?.status;

              const colors = getStatusColors(statusName);

              <div className="text-muted small text-end">
                <div>
                  {formatTime(start)} - {formatTime(end)}
                </div>

                {event.extendedProps?.display_booking_id && (
                  <div>
                    Booking ID: {event.extendedProps.display_booking_id}
                  </div>
                )}

                {event.extendedProps?.phone_number && (
                  <div>Phone: {event.extendedProps.phone_number}</div>
                )}
              </div>;
              return (
                <div
                  key={index}
                  className="mobile-booking-card"
                  onClick={() =>
                    handleAppointmentClick(
                      { details: event.extendedProps },
                      selectedDate
                    )
                  }
                >
                  <div className="d-flex justify-content-between align-items-start">
                    {/* Left Section */}
                    <div>
                      <div className="fw-semibold">
                        {Array.isArray(event.extendedProps?.providers)
                          ? event.extendedProps.providers.join(", ")
                          : event.extendedProps?.provider_name || event.title}
                      </div>

                      {event.extendedProps?.partner_name && (
                        <div className="text-muted small">
                          {event.extendedProps.partner_name}
                        </div>
                      )}

                      {statusName && (
                        <span
                          className="mobile-status"
                          style={{
                            backgroundColor: colors.bgColor,
                            color: colors.textColor,
                            border: `1px solid ${colors.borderColor}`,
                          }}
                        >
                          {statusName}
                        </span>
                      )}
                    </div>

                    {/* Right Section */}
                    <div className="text-end">
                      <div className="fw-semibold small">
                        {formatTime(start)} - {formatTime(end)}
                      </div>

                      {event.extendedProps?.user_name && (
                        <div className="small">
                          {event.extendedProps.user_name}
                        </div>
                      )}

                      {event.extendedProps?.phone_number && (
                        <div className="small text-muted">
                          {event.extendedProps.phone_number}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <AppointmentSidebar
  show={showCanvas}
  onHide={() => setShowCanvas(false)}
  canvasType={canvasType}
  editGroupId={editGroupId}
  selectedDate={selectedDate}
/>
        </div>
      </div>
    </>
  );
};

export default Dashboard;

